export default __webpack_public_path__ + "static/media/slider-2.ae28834b.jpg";